function GDPR() {
	// Appel seulement après navigation barba
	// l'appel à initCookieConsent() est déjà
	// fait par le plugin WP au premier chargement
	barbaCallbacks.push(this);
}

GDPR.prototype.build = function () {
	if (typeof initCookieConsent === 'function') {
		initCookieConsent();
	}
};
